<template>
  <div class="sp-template">
    <div class="h-title">内部员工</div>
    <el-card class="box-card">
      <!-- <div class="f-container">
        <div class="f-container__right">
          <div class="f-container__content"> -->
            <div slot="header" class="clearfix">
              <el-form :inline="true" :model="conditions" class="demo-form-inline" size="small">
                <el-form-item>
                  <el-input v-model="conditions.name" placeholder="请输入关键字搜索" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button v-if="in_configs(60104)" type="primary" @click="staffSearch">搜索</el-button>
                </el-form-item>
              </el-form>
              <h3>
                <el-button v-if="in_configs(60101)" size="small" class="btn-cyan" @click="addStaff">新建员工</el-button>
              </h3>
            </div>
            <el-table :data="staffData" stripe>
              <el-table-column prop="account" label="登录账号"></el-table-column>
              <el-table-column prop="name" label="姓名"></el-table-column>
              <el-table-column prop="roles.roleNames" label="角色" :formatter="formatRoleName"></el-table-column>
              <el-table-column prop="phone" label="联系方式"></el-table-column>
              <el-table-column prop="status" label="状态" :formatter="formatStatus"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <i v-if="in_configs(60102)" class="el-icon-edit-outline" @click="handleEdit(scope.$index, scope.row)" title="编辑"></i>
                </template>
              </el-table-column>
            </el-table>
          <!-- </div>
        </div>
      </div> -->
      <!-- 分页 -->
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[5, 10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="parseInt(total)">
      </el-pagination>
      <!-- 添加弹窗 -->
      <el-dialog :title="title" :visible.sync="dialogFormVisible" :before-close="emptyForm" @close="rulesForm('staffForm')" top="8vh">
        <el-form :model="staffForm" size="small" status-icon :rules="rules" ref="staffForm">
          <el-form-item label="登录账号" :label-width="formLabelWidth" prop="account">
            <el-input v-model.lazy="staffForm.account" auto-complete="off" placeholder="账号"></el-input>
          </el-form-item>
          <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
            <el-input v-model.lazy="staffForm.password" auto-complete="off" placeholder="密码"></el-input>
          </el-form-item>
          <el-form-item label="姓名" :label-width="formLabelWidth" prop="name">
            <el-input v-model.lazy="staffForm.name" auto-complete="off" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item label="角色" :label-width="formLabelWidth" prop="roleIds">
            <el-select v-model.lazy="staffForm.roleIds" multiple>
              <el-option v-for="item in roleName" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="联系方式" :label-width="formLabelWidth" prop="phone">
            <el-input v-model.lazy="staffForm.phone" auto-complete="off" placeholder="联系方式"></el-input>
          </el-form-item>
          <el-form-item label="启用状态" :label-width="formLabelWidth">
            <el-radio v-model="staffForm.status" label="1">启用</el-radio>
            <el-radio v-model="staffForm.status" label="0">停用</el-radio>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="close('staffForm')">取 消</el-button>
          <el-button size="small" type="primary" @click="submitStaffForm('staffForm')">确 定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    console.log(this.flag);
    // 验证员工账号是否存在
    var validateAccount = (rule, value, callback) => {
      if (this.flag) {
        if (value == this.staffData.account) {
          callback();
          return;
        }
      }
      this.$request1({
        method: 'POST',
        url: '/staff/check',
        params: { account: this.staffForm.account }
      })
        .then(response => {
          console.log(response.data.message);
          if (response.data.message == "account.already.exist") {
            callback(new Error("该账号已存在"));
          } else {
            callback();
          }
        })
        .catch(error => {
          console.log(error);
        });
    };
    var checkRoleName = (rule, value, callback) => {
      if (this.staffForm.roleIds == "") {
        callback(new Error("请选择角色"));
      } else {
        callback();
      }
    };
    return {
      title: "新建员工",
      conditions: {
        name: ""
      },
      staffData: [],
      staffForm: {
        id: "",
        name: "",
        roleIds: "",
        phone: "",
        account: "",
        password: "",
        status: "1"
      },
      roleName: [],
      rules: {
        name: [{ required: true, message: "请输入员工姓名", trigger: "blur" }],
        roleIds: [
          { required: true, validator: checkRoleName, trigger: "change" }
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: "blur" }
          // {
          //   pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{6,8}$/,
          //   message: "请输入正确的电话格式",
          //   trigger: "blur"
          // }
        ],
        account: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { validator: validateAccount, trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      },
      currentPage: 1, //当前页
      total: 1, //总条数
      pageSize: 10, //当前显示条数
      pageSizes: [10, 20, 50, 100], //显示条数
      dialogFormVisible: false,
      flag: false,
      status: 0,
      formLabelWidth: "120px"
    };
  },
  components: {},
  created() {
    this.$nextTick(() => {
      this.loadStaff(null, this.currentPage, this.pageSize);
    });
  },
  computed: {},
  watch: {},
  methods: {
    //搜索
    staffSearch() {
      this.loadStaff(this.conditions.name, this.currentPage, this.pageSize);
    },
    //加载数据
    loadStaff(name, currentPage, pageSize) {
      this.$request1({
        method: 'GET',
        url: '/staff/query',
        params: {
          name: name,
          currentPage: currentPage,
          pageSize: pageSize
        }
      })
        .then(response => {
          console.log(response.data);
          this.staffData = response.data.data;
          console.log(this.staffData);
          this.total = response.data.total;
        })
        .catch(error => {
          console.log(error);
        });
    },
    formatRoleName(data) {
      let roleNames = data.roles.roleNames;
      return roleNames.substring(1, roleNames.length - 1);
    },
    //转换状态显示：1：启用 0：停用
    formatStatus(data) {
      return data.status == "1" ? "启用" : "停用";
    },
    //编辑
    handleEdit(index, row) {
      console.log(index, row);
      this.title = row ? "编辑员工" : "新建员工";
      this.dialogFormVisible = true;
      this.getRoleNames();
      this.staffForm.id = row.id;
      this.staffForm.name = row.name;
      this.staffForm.roleIds = eval(row.roles.roleIds);
      this.staffForm.phone = row.phone;
      this.staffForm.account = row.account;
      this.staffData.account = row.account;
      this.staffForm.password = row.password;
      this.staffForm.status = row.status.toString();
      this.flag = true;
      this.status = 1;
    },

    // 获取角色列表
    getRoleNames() {
      console.log("getRoleNames");
      this.$request1({
        method: 'GET',
        url: '/staff/role',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          console.log(response.data);
          this.roleName = response.data;
          console.log(this.roleName);
        })
        .catch(error => {
          console.log(error);
        });
    },

    addStaff() {
      this.title = "新建员工";
      this.dialogFormVisible = true;
      this.flag = false;
      this.getRoleNames();
    },
    //添加/修改员工
    submitStaffForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.staffForm.password == "******") {
            this.staffForm.password = null;
          }
          this.$request1({
            method: 'POST',
            url: '/staff/save',
            data: this.staffForm
          })
            .then(response => {
              console.log(response);
              this.dialogFormVisible = false;
              this.$refs[formName].resetFields();
              this.loadStaff(null, this.currentPage, this.pageSize);
              this.emptyForm();
              this.success();
            })
            .catch(error => {
              console.log(error);
              this.$message.error("操作失败");
            });
          this.dialogFormVisible = false;
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    //清空表单数据
    emptyForm() {
      this.dialogFormVisible = false;
      this.staffForm.id = "";
      this.staffForm.name = "";
      this.staffForm.roleIds = [];
      this.staffForm.phone = "";
      this.staffForm.account = "";
      this.staffForm.password = "";
      this.staffForm.status = "1";
    },
    //清除验证
    close(formRule) {
      this.$refs[formRule].clearValidate();
      this.emptyForm();
    },
    rulesForm(formRule) {
      this.$refs[formRule].clearValidate();
    },
    //操作成功
    success() {
      if (this.status == 1) {
        this.$message({
          message: "修改成功",
          type: "success",
          center: true,
          duration: 1500
        });
      } else {
        this.$message({
          message: "添加成功",
          type: "success",
          center: true,
          duration: 1500
        });
      }
    },
    //分页
    handleSizeChange(pageSizes) {
      console.log(`每页 ${pageSizes} 条`);
      this.pageSize = pageSizes;
      this.loadStaff("",this.currentPage, pageSizes);
    },
    handleCurrentChange(currentPage) {
      console.log(`当前页: ${currentPage}`);
      this.loadStaff("",currentPage, this.pageSize);
    }
  }
};
</script>

<style lang="scss" scoped>
.f-container {
  margin: -20px 0;
}

.f-container__left {
  * + * {
    margin-top: 15px;
  }
}

h3 {
  font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/views/user/staff.vue